(() => {
  class ExtHeaderDrawerSearch {
    constructor(root = document) {
      this.root = root;
      this.onClick = this.onClick.bind(this);

      this.root.addEventListener('click', this.onClick, true);
    }

    destroy() {
      this.root.removeEventListener('click', this.onClick, true);
    }

    onClick(event) {
      if (!document.querySelector('.menu-drawer--custom, .menu-drawer--ab')) return;

      const target = this.getElementTarget(event.target);

      if (!target) return;

      if (target.closest('[data-ext-drawer-search-submit]')) {
        event.stopImmediatePropagation();
        return;
      }

      const resetButton = target.closest('[data-ext-drawer-search-reset]');

      if (!resetButton) return;

      this.resetSearch(event, resetButton);
    }

    getElementTarget(target) {
      if (!target) return null;

      return target.nodeType === Node.ELEMENT_NODE ? target : target.parentElement;
    }

    resetSearch(event, resetButton) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const searchWrapper = resetButton.closest('.ext-menu-drawer__predictive-search');
      const input = searchWrapper ? searchWrapper.querySelector('.ext-menu-drawer__search-input') : null;

      if (searchWrapper && typeof searchWrapper.close === 'function') {
        searchWrapper.close(true);
      }

      if (input) {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }

      resetButton.classList.add('hidden');
    }
  }

  window.ExtHeaderDrawerSearch = ExtHeaderDrawerSearch;

  window.initializeExtHeaderDrawerSearch = () => {
    if (window.extHeaderDrawerSearch && typeof window.extHeaderDrawerSearch.destroy === 'function') {
      window.extHeaderDrawerSearch.destroy();
    }

    window.extHeaderDrawerSearch = document.querySelector('.menu-drawer--custom, .menu-drawer--ab') ? new ExtHeaderDrawerSearch() : null;
  };

  if (!window.extHeaderDrawerSearchEventsBound) {
    window.extHeaderDrawerSearchEventsBound = true;

    document.addEventListener('shopify:section:load', () => {
      if (window.initializeExtHeaderDrawerSearch) window.initializeExtHeaderDrawerSearch();
    });

    document.addEventListener('shopify:section:unload', () => {
      if (window.initializeExtHeaderDrawerSearch) window.initializeExtHeaderDrawerSearch();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initializeExtHeaderDrawerSearch, { once: true });
  } else {
    window.initializeExtHeaderDrawerSearch();
  }
})();
